import { firebaseEnabled, auth } from './firebase';

export async function getAuthIdToken(): Promise<string | null> {
  try {
    if (!firebaseEnabled || !auth) return null;
    const user = auth.currentUser;
    if (!user) return null;
    const token = await user.getIdToken();
    return token || null;
  } catch (e) {
    console.warn('Failed to get auth token:', e);
    return null;
  }
}

